import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IKeHoachLopSaveRequest } from "../../model/request/ke-hoach/IKeHoachLopSaveRequest";
import { IKeHoachLopSelectRequest } from "../../model/request/ke-hoach/IKeHoachLopSelectRequest";
import { apiClient } from "../apiClient";
export const KE_HOACH_LOP_ENDPOINT = "ke-hoach-lop";

export const keHoachLopApi = {
    Select: (request: IKeHoachLopSelectRequest) => apiClient.post(`${KE_HOACH_LOP_ENDPOINT}/select`, request),
    Save: (request: IKeHoachLopSaveRequest) => apiClient.post(`${KE_HOACH_LOP_ENDPOINT}`, request),
    Deletes: (request: IIdsRequest) => apiClient.put(`${KE_HOACH_LOP_ENDPOINT}/deletes`, request),
};
